import { Box } from '@mui/material';
import React from 'react'
import CustomizedTables from '../../common/Table';
import { listEnquiries, deleteEnquiry } from './Enquiry.service';

const Enquiry = () => {
    const columns: any[] = [
        { key: "name", label: "Name", minWidth: 150 },
        { key: "email", label: "Email", minWidth: 130 },
        { key: "phone", label: "Mobile Number", minWidth: 150 },
        { key: "type", label: "Property Type", minWidth: 100 },
        { key: "description", label: "Description", minWidth: 250 },
        { key: "status", label: "Status", minWidth: 100 },
    ];
    return (
        <Box sx={{ paddingY: 6, width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>Property Enquiries</h2>
            </Box>
            <CustomizedTables
                columns={columns}
                listService={listEnquiries}
                deleteService={deleteEnquiry}
                isUser={true}
            />
        </Box>
    );
}

export default Enquiry
